var map = {
	"./audio-placeholder": 537,
	"./audio-placeholder.png": 537,
	"./avatar-missing": 496,
	"./avatar-missing.png": 496,
	"./avatar-missing.svg": 1028,
	"./header-missing": 502,
	"./header-missing.png": 502,
	"./soapbox-logo": 503,
	"./soapbox-logo-white": 504,
	"./soapbox-logo-white.svg": 504,
	"./soapbox-logo.svg": 503,
	"./video-placeholder": 538,
	"./video-placeholder.png": 538,
	"./void": 539,
	"./void.png": 539,
	"./web-push/web-push-icon_expand": 1010,
	"./web-push/web-push-icon_expand.png": 1010,
	"./web-push/web-push-icon_favourite": 1011,
	"./web-push/web-push-icon_favourite.png": 1011,
	"./web-push/web-push-icon_reblog": 1012,
	"./web-push/web-push-icon_reblog.png": 1012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1027;